<template>
    <div>
        <Header />
        <div class=" row row-bottom-0 wow-factor-bg" >
            
            <div class="col s12 m6 l4 offset-m3 offset-l4 page-height">
                <div class="form-mask">
                    <div class="center">
                        <div><img class="complete-img" src="/assets/img/complete.svg" /></div>
                        <div class="thank-you-note center">
                            Thank You for your interest in<br/>
                            becoming a Zapy Partner!
                       </div>
                       <div class="short-message">We'll get back to you within 2 business days.</div>
                       <div class="btn-margin-top"><router-link to="/" class="btn btn-large">Back to Overview</router-link></div>
                    </div>                                    
                </div>

            </div>
       
        </div>        
        <Footer />
    </div>

</template>
<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  name: "thankyou",
  components: {
    Header,
    Footer
  }
};
</script>
